import React, { PureComponent } from "react";
import { UploadWithTitle } from "../uploadAttachmentsWithTitle";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  FILE_SIZE_LIMIT,
  OTHER_FORMATS,
  VIDEO_FORMATS,
  FILE_SIZE_LIMIT_AGENDA,
  DOCUMENT_FORMATS
} from "../../../constant";

// actions
import {
  uploadFileAction,
  uploadFileTitleAction
} from "../../../actions/common.action";

// helpers
import { FormDataForImage } from "../../../helper";
import { toast } from "react-toastify";
import { getUploadAttachmentApiResponse } from "../helper";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class UploadAttchementsWithTitle extends PureComponent {
  MAX_UPLOADS = 1;

  state = {
    response: {},
    attachments: [],
    fileUploadPercentage: 0
  };

  componentDidUpdate(prevProps, prevState) {
    const { attachments } = this.state;
    const { onSubmit, isFromManualDownload } = this.props;

    if (Object.keys(this.state.response).length < 1) {
      return;
    }

    const { data, status, message } = this.state.response || {};

    const prevResponseDataId = prevState.response
      ? prevState.response.data
        ? prevState.response.data.id
        : null
      : null;

    if (data !== null && prevResponseDataId === data.id) {
      return;
    }

    if (data && data.id && this.state.attachments[0].title) {
      uploadFileTitleAction(undefined, {
        fid: data.id,
        title: attachments[0].title
      }).then(result => {
        const { status, message } = result;

        if (!status) {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          ); // message will show in case of error while uploading title
        } else {
          toast.success(
            <p className="toast-text-alignment">
              {isFromManualDownload ? "Manual Updated Successfully" : message}
            </p>,
            successToastStyle
          );
        }
      });
    } else {
      // after file
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
    }

    if (status) {
      // onSubmit from props must retun a promise
      if (typeof onSubmit === "function") {
        onSubmit({ ...data, title: attachments[0].title }).then(() => {
          this.setState(
            {
              isLoading: false
            },
            () => {
              const params =
                data && data.id
                  ? { ...data, title: this.state.attachments[0].title }
                  : {};
              this.onClose(params); // close the modal
            }
          );
        });
      }
    }
  }

  onRemoveFiles = index => {
    // remove by index
    this.setState(prevState => {
      prevState.attachments.splice(index, 1);
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onClose = uploaded => {
    const { onCloseModal = () => {} } = this.props;
    if (
      this.state.fileUploadPercentage > 0 &&
      this.state.fileUploadPercentage <= 100 &&
      !uploaded
    ) {
      let exitUpload = window.confirm(
        "File upload in progress, are you sure you want to cancel?"
      );
      if (exitUpload) {
        typeof onCloseModal === "function" && onCloseModal(uploaded);
      }
    } else {
      typeof onCloseModal === "function" && onCloseModal(uploaded);
    }
  };

  onSubmit = () => {
    try {
      const {
        uploadFileAction,
        onSubmit,
        fileSizeLimit,
        forFileSize
      } = this.props;
      //const fileSizeLimitOtherFormats = fileSizeLimit
      // ? fileSizeLimit
      // : FILE_SIZE_LIMIT.OTHER_FORMATS;

      let fileSizeLimitOtherFormats = FILE_SIZE_LIMIT.OTHER_FORMATS;
      if (fileSizeLimit) {
        fileSizeLimitOtherFormats = fileSizeLimit;
      } else if (forFileSize) {
        fileSizeLimitOtherFormats = FILE_SIZE_LIMIT_AGENDA.OTHER_FORMATS;
      }

      const isMis = Boolean(fileSizeLimit);
      console.log("AMIT", forFileSize);
      //const maxFileSizeLimit = isMis ? "25 MB" : "10 MB";
      //const maxFileSizeLimit = isMis ? (fileSizeLimit ? "30 MB" : "25 MB") : "10 MB";
      let maxFileSizeLimit = "10 MB";
      if (isMis) {
        maxFileSizeLimit = "25 MB";
      } else if (forFileSize) {
        maxFileSizeLimit = "30 MB";
      }
      const errorMessage = `The file exceeds the maximum size limit of ${maxFileSizeLimit}`;
      const { attachments } = this.state;
      const attachmentPayload = FormDataForImage(attachments, "file");
      const extension = attachments[0].name
        .substr(
          attachments[0].name.lastIndexOf(".") + 1,
          attachments[0].name.length
        )
        .toLowerCase();
      if (!attachments.length || !attachments[0].title) {
        toast.error(
          <p className="toast-text-alignment">
            Document and title of file is mandatory
          </p>,
          errorToastStyle
        );
      }
      if (
        attachments[0].size > FILE_SIZE_LIMIT.VIDEO_FORMAT &&
        VIDEO_FORMATS.includes(extension)
      ) {
        toast.error(
          <p className="toast-text-alignment">
            The file exceeds the maximum size limit of 250 MB or duration limit
            of 60s
          </p>,
          errorToastStyle
        );
      } else if (
        attachments[0].size > fileSizeLimitOtherFormats &&
        OTHER_FORMATS.includes(extension)
      ) {
        toast.error(
          <p className="toast-text-alignment">{errorMessage}</p>,
          errorToastStyle
        );
      } else {
        this.setState(
          {
            isLoading: true
          },
          () => {
            if (isMis) {
              this.getUploadAttachmentDetail(isMis);
            } else if (forFileSize) {
              this.getUploadAttachmentDetailAgenda(forFileSize);
            } else {
              this.getUploadAttachmentDetail(isMis);
            }
          }
        );
      }
    } catch (error) {
      console.error(
        `Error while uplading image on agenda detail ${error.message}`
      );
    }
  };
  // onSubmit = () => {
  //   try {
  //     const { uploadFileAction, onSubmit, fileSizeLimit } = this.props;
  //     const fileSizeLimitOtherFormats = fileSizeLimit
  //       ? fileSizeLimit
  //       : FILE_SIZE_LIMIT.OTHER_FORMATS;
  //     const isMis = Boolean(fileSizeLimit);
  //     const maxFileSizeLimit = isMis ? "25 MB" : "10 MB";
  //     const errorMessage = `The file exceeds the maximum size limit of ${maxFileSizeLimit}`;
  //     const { attachments } = this.state;
  //     const attachmentPayload = FormDataForImage(attachments, "file");
  //     const extension = attachments[0].name
  //       .substr(
  //         attachments[0].name.lastIndexOf(".") + 1,
  //         attachments[0].name.length
  //       )
  //       .toLowerCase();
  //     if (!attachments.length || !attachments[0].title) {
  //       toast.error(
  //         <p className="toast-text-alignment">
  //           Document and title of file is mandatory
  //         </p>,
  //         errorToastStyle
  //       );
  //     }
  //     if (
  //       attachments[0].size > FILE_SIZE_LIMIT.VIDEO_FORMAT &&
  //       VIDEO_FORMATS.includes(extension)
  //     ) {
  //       toast.error(
  //         <p className="toast-text-alignment">
  //           The file exceeds the maximum size limit of 250 MB or duration limit
  //           of 60s
  //         </p>,
  //         errorToastStyle
  //       );
  //     } else if (
  //       attachments[0].size > fileSizeLimitOtherFormats &&
  //       OTHER_FORMATS.includes(extension)
  //     ) {
  //       toast.error(
  //         <p className="toast-text-alignment">{errorMessage}</p>,
  //         errorToastStyle
  //       );
  //     } else {
  //       this.setState(
  //         {
  //           isLoading: true
  //         },
  //         () => {
  //           this.getUploadAttachmentDetail(isMis);
  //         }
  //       );
  //     }
  //   } catch (error) {
  //     console.error(
  //       `Error while uplading image on agenda detail ${error.message}`
  //     );
  //   }
  // };
  calculateUploadingPercentage = e => {
    const { fileUploadPercentage } = this.state;
    var percentComplete = Math.ceil((e.loaded / e.total) * 100);
    this.setState({
      fileUploadPercentage: percentComplete
    });
  };
  //For Agenda Only
  getUploadAttachmentDetailAgenda = forFileSize => {
    const { attachments } = this.state;
    const attachmentPayload = FormDataForImage(attachments, "file");
    attachmentPayload.append("forFileSize", forFileSize);
    getUploadAttachmentApiResponse(
      attachmentPayload,
      this.calculateUploadingPercentage,
      this.uploadAttachmentApiCallback
    );
  };

  getUploadAttachmentDetail = isMis => {
    const { attachments } = this.state;
    const attachmentPayload = FormDataForImage(attachments, "file");
    attachmentPayload.append("isMis", isMis);
    getUploadAttachmentApiResponse(
      attachmentPayload,
      this.calculateUploadingPercentage,
      this.uploadAttachmentApiCallback
    );
  };
  uploadAttachmentApiCallback = http => {
    var response = {};
    // checking readyState === 4 which means that the request
    // had been sent, the server had finished returning the response and
    // the browser had finished downloading the response content.
    if (http.readyState === 4 && http.status === 200) {
      response = http.response;
      this.setState({
        response: JSON.parse(response)
      });
    }
  };

  onTitleChange = e => {
    const { value } = e.target;
    this.setState(prevState => {
      prevState.attachments[0]["title"] = value;
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onEditToggle = index => {
    // remove by index
    this.setState(prevState => {
      prevState.attachments[index]["toggleEdit"] = !prevState.attachments[
        index
      ]["toggleEdit"];
      return {
        attachments: [...prevState.attachments]
      };
    });
  };

  onAttachment = e => {
    try {
      const { files } = e.target;
      const { fileFormats } = this.props;
      // max 1 file can be uploaded at a time
      if (files.length > this.MAX_UPLOADS) {
        toast.error(
          <p className="toast-text-alignment">
            Max one file can uploaded at a time.
          </p>,
          errorToastStyle
        );
        return false;
      }

      // if file type is invalid
      const validFormat = fileFormats.find(value => {
        return files[0].name.toLowerCase().endsWith(value);
      });
      if (!validFormat) {
        toast.error(
          <p className="toast-text-alignment">File type not supported</p>,
          errorToastStyle
        );
        return false;
      }

      //
      this.setState(() => {
        // files
        const attachments = [];
        // attachments
        for (let i = 0; i < files.length; i++) {
          files[i].toggleEdit = true;
          files[i].title = "";
          attachments.push(files[i]);
        }

        return {
          attachments
        };
      });
    } catch (e) {
      console.error(`Error while file section ${e.message}`);
    }
  };

  render() {
    const {
      props: {
        displayModal,
        fileFormats,
        canUploadVideo,
        isFromManualDownload
        // forFileSize
      },
      state: { isLoading, attachments, fileUploadPercentage, response },
      onClose,
      onSubmit,
      onEditToggle,
      onTitleChange,
      onRemoveFiles,
      onAttachment
    } = this;
    window.onbeforeunload = function confirmExit() {
      if (Object.keys(response).length === 0 && fileUploadPercentage > 0) {
        return window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );
      }
    };
    return displayModal ? (
      <UploadWithTitle
        onClose={onClose} // on close of modal function
        title={
          canUploadVideo ? (
            <>
              <div>
                <h6 className="file-formats text-center">
                  {isFromManualDownload ? (
                    <>Only pdf file format is supported</>
                  ) : (
                    <> Only {fileFormats.join(" ")} file format is supported</>
                  )}
                </h6>
                <hr className="horizontal-line-attachment" />
                <div className="text-center max-size-display-message">
                  Max Size:<b> Video</b> 250 MB(duration: 60s) |{" "}
                  <b> Other Files</b> 10 MB
                </div>
              </div>
            </>
          ) : (
            <>
              <div>
                <h6 className="file-formats text-center">
                  {isFromManualDownload ? (
                    <>Only pdf file format is supported</>
                  ) : (
                    <> Only {fileFormats.join(" ")} file format is supported</>
                  )}
                </h6>
              </div>
            </>
          )
        }
        titleField={true}
        onEditToggle={onEditToggle}
        isLoading={isLoading}
        onRemoveFile={onRemoveFiles}
        onUpload={onSubmit}
        onTitleUpdate={onTitleChange}
        onAttachFile={onAttachment}
        attachments={attachments}
        containerClass="agenda-detail-attachments"
        fileFormats={fileFormats}
        loadingPercent={fileUploadPercentage}
        // forFileSize={forFileSize}
      />
    ) : null;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadFileAction
    },
    dispatch
  );
}

const UploadAttachmentsWithTitleComponent = connect(
  null,
  mapDispatchToProps
)(UploadAttchementsWithTitle);
export { UploadAttachmentsWithTitleComponent };
